import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from '@/core/service/logger-service';
import { MsgService } from '@/core/service/msg.service';

/**
 * Catches errors Angular's zone/renderer surfaces that no component or HTTP
 * mixin caught (template expression throws, signal computation throws, etc).
 * HttpErrorResponses are skipped here since the HTTP interceptor / CRUD
 * mixins already report those via ui.msg.error with feature-specific copy.
 */
@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    private readonly logger = inject(LoggerService);
    private readonly msg = inject(MsgService);
    private readonly translate = inject(TranslateService);

    handleError(error: unknown): void {
        this.logger.error('Uncaught application error', error);

        if (error instanceof HttpErrorResponse) return;

        this.msg.error(
            this.translate.instant('dialog-status.failed'),
            this.translate.instant('dialog-status.failed-description'),
        );
    }
}
